// extracted by mini-css-extract-plugin
export default {"title":"ErrorPageHeader-module__title--IbB+V","subtitle":"ErrorPageHeader-module__subtitle--td5Mq","icon":"ErrorPageHeader-module__icon--3GBzv"};